import { isObject } from 'lodash/fp';
import type { WrappedFieldMetaProps } from 'redux-form';
import { hasInputError, LocalizedText, LocalizedTextProps } from '@mews/framework';

export const getError = (meta: WrappedFieldMetaProps) => {
    if (!hasInputError(meta)) {
        return null;
    }

    const { error } = meta;

    return isObject(error) ? <LocalizedText {...(error as LocalizedTextProps)} /> : <LocalizedText textKey={error} />;
};
